module.exports = "/_next/static/resources/photo-2-a250774d81cd9d3213b0aaab32c90190.jpg";